<script setup lang="ts">
import type { Values } from '@/composables/useValues'

const props = defineProps<{
    country: Country
    data: Values<Import>
    condensed?: boolean
}>()

/**
 * Get an import total value.
 */
function getImportTotalValue(values: Import['products']) {
    return values.reduce((acc, curr) => {
        return acc + curr.import_value
    }, 0)
}

/**
 * Get the overall total value of all imports.
 */
const totalValue = computed(() => {
    if (!props.data.data) return 0

    return props.data.data.reduce((acc, curr) => {
        return acc + getImportTotalValue(curr.products)
    }, 0)
})

/**
 * Get the import total value of the current country.
 */
const currentCountryValue = computed(() => {
    return getImportTotalValue(props.data.countryData?.products ?? [])
})

/**
 * Translations.
 */
const { t } = useI18n()

const htmlString = computed(() => {
    return t('import-risk-total', {
        country: `<span class="text-earth-red font-bold">${props.country.name}</span> `,
        value: `<span class="text-black font-bold">${props.data.formatter(
            unref(currentCountryValue)
        )}
        </span>`,
        total: `<span class="text-black font-bold">${props.data.formatter(
            unref(totalValue)
        )}</span>`
    })
})
</script>

<template>
    <p
        v-if="!condensed"
        class="max-w-md text-base !leading-none xl:text-lg 2xl:text-xl"
        v-html="htmlString"
    />
</template>